/**
 * 定義ファイル
 * 環境関連以外の定義はここで管理します
 */
/** テーブルデフォページサーズ */
export const DEFAULT_PAGE_SIZE = 10;
/** テーブル設定を管理するためのIF */
export interface TableConfig {
  pageSize: number;
  pageIndex: number;
  columnWidths: number[];
}

/** MFA記録時間 */
export const MFA_SKIP_DAYS = 90;

export const USER_TYPE = {
  DOCOMO: "01", // ドコモ
  MERCHANT_GEN: "02", // 一般申請事業者
  MERCHANT_INC: "03", // 包括申請事業者
  HD: "04",
  GW: "05",
};

export const USER_TYPE_MER_HD = ["02", "03", "04"]; // 一般申請事業者 包括申請事業者 HD事業者

// 権限一覧
export const PERMISSIONS = {
  GW: "gw",
  HD: "hd",
  EXAMINE: "examine",
  PROGRESS: "progress",
  APPLY_COMPANY_LIST: "apply_company_list",
  APPLY_COMPANY_READ: "apply_company_read",
  APPLY_COMPANY_EDIT: "apply_company_edit",
  APPLY: "apply",
  RATE_SETTING: "rate_setting",
  INDIVIDUAL_COUNSELING: "individual_counseling",
  ACCOUNT: "account",
  MASTER_EDIT: "master_edit",
  MASTER_APPROVAL: "master_approval",
  RATE_READ: "rate_read",
  APPLY_MERCHANT_DIRECT: "apply_merchant_direct",
};

/**
 * コードリストタイプ一覧
 */
export const CODE_TYPE = {
  COMPANY_TYPE: "company_type",
  DEACTIVATED_REASON: "deactivated_reason",
  APPLICATION_STATUS: "application_status", // 申請状況
  APPLICATION_DETAIL_STATUS: "application_detail_status", // 申請状況詳細
  APPLICATION_TYPE: "application_type",
  INDIVIDUAL_HANDLING_REASON: "individual_handling_reason",
  ANNOUNCEMENT_CATEGORY: "announcement_category",
  APPLICATION_FORM_TYPE: "application_form_type",
};

/**
 * 更新差分
 */
export const UPDATE_DIFFERENCIAL = {
  NEW: "新規",
  NEW_ADD: "新規・追加",
  UPDATE: "変更",
  CANCELLATION: "解約",
};
